import ResponsiveImage from "./ResponsiveImage";

export default ResponsiveImage;
